import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCardBlank } from "@fortawesome/pro-light-svg-icons";
import Logo from "../../components/Logo";
import { pinwheelPalette } from "@/styles/theme.ts";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";

export const MissingPaymentMethod = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const { t } = useTranslation("rare");

  return (
    <Grid container justifyContent="center">
      <Grid size={{ xs: 11, sm: 9, md: 8, lg: 6 }}>
        <Box sx={{ textAlign: "center" }}>
          <Box sx={{ mb: 2 }}>
            <Logo />
          </Box>
          <Box sx={{ mb: 2, color: "text.secondary" }}>
            <FontAwesomeIcon icon={faCreditCardBlank} size="3x" />
          </Box>
          <Typography variant={isXs ? "h4" : "h3"} component="h1" sx={{ mb: 2 }}>
            {t("missingPaymentMethod")}
          </Typography>
          <Typography sx={{ color: "text.secondary", mb: 3 }}>
            {t("missingPaymentMethodDesc")}
          </Typography>
        </Box>
        <Box className="pageMainContent">
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
              {t("contactCustomerCare")}
            </Typography>
            <Typography sx={{ mb: 1 }}>
              {t("reachCustomerCareVia")}{" "}
              <a href="https://support.pinwheel.com/hc/en-us" target="_blank" rel="noreferrer" style={{ textDecoration: "underline", color: pinwheelPalette.purple[100] }}>
                {t("liveChat", { ns: "common" })}
              </a>{" "}
              {t("or", { ns: "common" })}{" "}
              <a href="tel:8889037977" style={{ textDecoration: "underline", color: pinwheelPalette.purple[100] }}>{"(888) 903-7977"}</a>.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};
